module.exports = "https://dev.stanwinstonschool.com/ironman.57b23a4d8c1e5a458edfb1ef19a00e0e.jpg";